/*
 * ****************************************************************************
 *     Copyright (C)  Motorola Solutions, INC.
 *     All Rights Reserved.
 *     Motorola Solutions Confidential Restricted.
 * ****************************************************************************
 */

import { createAction, props } from "@ngrx/store";

export const updateAgentFilter = createAction('[Supervisor View] Update Agent Filter', props<{ filter: string }>());
export const updateQueueFilter = createAction('[Supervisor View] Update Queue Filter', props<{ filter: string }>());
export const updateCallFilter = createAction('[Supervisor View] Update Call Filter', props<{ filter: string }>());
export const updateTabIndex = createAction('[Supervisor View] Update Tab Index', props<{ index: number }>());
